export default __webpack_public_path__ + "static/media/LogoMGP.6807858b.jpg";